'use client';

import useAuth from '@/hooks/use-auth';

export default function AuthProvider({
  children,
  headerToken,
}: {
  children: React.ReactNode;
  headerToken?: string;
}) {
  useAuth(headerToken);
  return <>{children}</>;
}
